import React, {Fragment} from 'react';
import ScrollAnimation from 'react-animate-on-scroll';


export default function Contact() {

  return (
    <Fragment>
      <ScrollAnimation animateIn='fadeIn' animateOut='fadeOut'>       
        <div id="contact-section" className=" pt-4 contact-container">
            <h1 className="contact-heading pl-2 pb-3">Get in touch.</h1>
            <a href="tel:+353-086-088-1112" className="contact-text pl-3 pt-3">(IE) +353(86) 088-1112</a>
            <br></br>
            <a href="tel:+1-206-809-0230" className="contact-text pl-3 pt-3">(USA) +1(206) 809-0230 </a>
            <br></br>
            <a href = "mailto: davidmcateer@gmail.com" className="contact-text pl-3 pt-3">dav.mcateer@gmail.com</a>
            <br></br>
            <a className="contact-text pl-3 pt-1" href="https://www.linkedin.com/in/david-mcateer/">linkedin</a>
            <br></br>
            <a className="contact-text pl-3 pt-1" href="https://www.linkedin.com/in/phoebe-staab-52587b150/">Website created with help from - Phoebe Staab :)</a>
        </div>
      </ScrollAnimation>
    </Fragment>
  );
}